import axios from 'axios';
import { ADD_USER } from '../../constants';

export const createUser = (data, onError, onClose) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(addUser());
  axios
    .post(`admin/createUser`, data, config)
    .then((res) => {
      dispatch(setUser(res));
      onClose();
    })
    .catch((err) => {
      dispatch(errorUser(err.response));
      onError(err.response);
    });
};

export const addUser = () => ({
  type: ADD_USER.LOAD,
});

export const setUser = (data) => ({
  type: ADD_USER.SUCCESS,
  payload: data.data,
});

export const errorUser = (error) => ({
  type: ADD_USER.FAIL,
  payload: error,
});
